<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/productBom',title:'套餐管理'},{title:'套餐审批'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                        <h1>套餐主体</h1>
                    </div>
                    <div class="pieceCon n-bu">
                        <div class="h-pieceCon2">
                            <el-form :model="f" label-position="right" ref="f" :inline="true"
                                         class="demo-ruleForm h-formbLine h-formbLine1">
                                    <div class="h-rowCon Bianji">
                                        <div class="h-rowCon1 Bianji">
                                            <el-form-item label="套餐类型" class="h-elformWrap-2">
                                                <brselect placeholder="请选择"
                                                          category="package_type"
                                                          :v="f.packageType"
                                                          disabled=""
                                                          clearable
                                                          v-model="f.packageType">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2" v-if="!isShouh">
                                                <brselect placeholder="请选择"
                                                          category="xsyb_lianqun"
                                                          :v="f.lianqunCode"
                                                          clearable
                                                          disabled
                                                          @change="getSceneList"
                                                          v-model="f.lianqunCode">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2" v-if="isShouh">
                                                <el-input disabled v-model="f.lianqunName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="场景" class="h-elformWrap-2" v-if="this.showSence">
                                                <el-input disabled v-model="f.sceneName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="子场景" class="h-elformWrap-2" v-if="this.showChildSence">
                                                <el-input disabled v-model="f.childSceneName"></el-input>
                                            </el-form-item>

                                            <el-form-item label="套餐描述" disable class="h-elformWrap-2" prop="packageName">
                                                <el-input placeholder="请输入套餐描述" disabled v-model="f.packageName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否整单发货" class="h-elformWrap-2" prop="isTj">
                                                <el-select v-model="f.isWhole" disabled placeholder="请选择">
                                                    <el-option label="否" value="0"></el-option>
                                                    <el-option label="是" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否计入场景收入" class="h-elformWrap-2" prop="isTj">
                                                <el-select v-model="f.isSceneIncome" disabled placeholder="请选择">
                                                    <el-option label="否" value="0"></el-option>
                                                    <el-option label="是" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否允许单品销售" class="h-elformWrap-2" prop="isTj">
                                                <el-select v-model="f.isSingleSale" disabled placeholder="请选择">
                                                    <el-option label="否" value="0"></el-option>
                                                    <el-option label="是" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="税率" class="h-elformWrap-2" prop="isTj">
                                                <el-select v-model="f.shuilv" placeholder="请选择">
                                                    <el-option label="6%" value="JQ"></el-option>
                                                    <el-option label="9%" value="J5"></el-option>
                                                    <el-option label="13%" value="JC"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="税分类编码" class="h-elformWrap-2" prop="taxcode">
                                                <el-input placeholder="请输入税分类编码" disabled v-model="f.taxCode" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="是否中转" class="h-elformWrap-2" prop="isTransit">
                                                <el-select v-model="f.isTransit" disabled placeholder="请选择">
                                                    <el-option label="否" value="0"></el-option>
                                                    <el-option label="是" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" v-if="showTransit" prop="contactPerson">
                                                <el-input placeholder="请输入联系人" disabled v-model="f.address"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" v-if="showTransit" prop="contactPerson">
                                                <el-input placeholder="请输入联系人" disabled v-model="f.contactPerson"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系方式" class="h-elformWrap-2" v-if="showTransit" prop="phone">
                                                <el-input placeholder="请输入联系方式" disabled v-model="f.phone"></el-input>
                                            </el-form-item>
                                            <el-form-item label="套餐价格" class="h-elformWrap-2" prop="packagePrice">
                                                <el-input v-model="f.packagePrice"  disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="套餐开始时间" class="h-elformWrap-2">
                                                <el-date-picker
                                                        placeholder="请选择"
                                                        v-model="f.startTime"
                                                        :clearable="false"
                                                        type="date"
                                                        value-format="yyyy-MM-dd" >
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="套餐结束时间" class="h-elformWrap-2">
                                                <el-date-picker
                                                        placeholder="请选择"
                                                        v-model="f.endTime"
                                                        :clearable="false"
                                                        type="date"
                                                        value-format="yyyy-MM-dd" >
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="指定经销商" class="h-elformWrap-2" prop="agentName" v-if="showSence">
                                                <el-input disabled v-model="f.agentName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="销售公司" required class="h-elformWrap-2">
                                                <brselect placeholder="请选择"
                                                          category="xsyb_gongsi"
                                                          :v="f.companycode"
                                                          disabled=""
                                                          clearable
                                                          v-model="f.companycode">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="客户范围" required v-if="!showSence" class="h-elformWrap-2">
                                                <desselect placeholder="请选择"
                                                          :disabled="!this.caiwuFlag"
                                                           :multiple="true"
                                                           category="rebate_type"
                                                          :v="f.useLianqun"
                                                          clearable
                                                          v-model="f.useLianqun">
                                                </desselect>
                                            </el-form-item>
                                            <el-form-item label="附件" class="h-elformWrap-2">
                                                <brupload
                                                        v-model="f.tcFileUrl"
                                                        :refid=bomId
                                                        reftype="TC_GC"
                                                        :limit="1"
                                                        :showtime="false"
                                                        @filecallback=mfIsUpload>
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </el-form>
                        </div>
                    </div>
                </div>
                <div class="n-hu ljjtablepaddings9" >
                    <div class="h-pieceTitle2">
                        <h1>套餐产品</h1>
                    </div>
                    <div class="yxtable" style="padding-left: 0.15rem;">
                        <el-table
                                ref="multipleTable"
                                :data="bomDetailData"
                                style="width: 100%"
                                :border="true"
                                max-height="440"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="prodcode"
                                    label="产品编码"
                                    width="140"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="promodel"
                                    label="产品型号"
                                    width="140"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proModelName"
                                    label="产品大类"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    min-width="150"
                                    prop="shareModelName"
                                    :show-overflow-tooltip="true"
                                    label="共享大类">
                            </el-table-column>
                            <el-table-column
                                    prop="isFw"
                                    label="是否服务产品"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template scope="scope">
                                    <span v-if="scope.row.isFw == '1'">是</span>
                                    <span v-if="scope.row.isFw == '0'">否</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="num"
                                    label="数量"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="isTj"
                                    label="是否特价"
                                    v-if="showTj"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template scope="scope">
                                    <span v-if="scope.row.isTj == '1'">是</span>
                                    <span v-if="scope.row.isTj == '0'">否</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="tjid"
                                    v-if="showTj"
                                    label="特价版本"
                                    width="140"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="tjUsername"
                                    label="特价公司"
                                    v-if="showTj"
                                    :show-overflow-tooltip="true"
                                    width="150"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="proPrice"
                                    label="产品一级价"
                                    width="100"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="finalPrice"
                                    label="成交价"
                                    width="100"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="isMain"
                                    label="是否主品"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template scope="scope">
                                    <span v-if="scope.row.isMain == '1'">是</span>
                                    <span v-if="scope.row.isMain == '0'">否</span>
                                </template>
                            </el-table-column>

                        </el-table>

                    </div>
                </div>

            </div>
            <div class="h-table h-mrt30 h-rowBox" style="margin-top:0.8rem">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:20px">套餐审批</h1>
                    <el-form :model="bomshenpi" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 w-elformWrap-3" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                            <el-input v-model="bomshenpi.shenheyijian" placeholder="请输入"
                                      :disabled="taskstatus==1" ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-row style="display: flex;justify-content: center;margin: 30px 0;">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
            <el-button class="h-btn h-bBtn h-bgred" @click="tongguobohui(1)" v-if="taskstatus==0">驳回</el-button>
            <el-button class="h-btn h-bBtn h-bggreen" @click="tongguobohui(2)"  v-if="taskstatus==0">通过</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                //带线表单
                f: {
                    bomDetailList:[],
                    lianqunCode:'',
                    lianqunName:'',
                    sceneCode:'',
                    packageName:'',
                    taxCode:'',
                    startTime:'',
                    endTime:'',
                    isTj:0,
                    packagePrice:0,
                    isFl:0,
                    isWhole:0,
                    isStep:0,
                    isTransit:0,
                    phone:null,
                    address:null,
                    contactPerson:null,
                    isSceneIncome:null,
                    isSingleSale:null,
                    tcFileUrl:null,
                    isPolicy:null,
                    packageType:null,
                    agentName: null,
                    companycode:null,
                    useScope:null,
                    useLianqun:null,
                },
                bomDetailData:[
                     {
                         prodcode:'',
                         promodel:'',
                         num:'',
                         proModelCode:'',
                         proPrice:'',
                         finalPrice:'',
                         isGx:0,
                         protype:'',
                         smList: [],
                         shareModelCode: '',
                         shareModelName: '',
                         taxRate:'',
                         isFw:'0',
                    }
                ],
                options: [{
                    value: 'all',
                    label: '全选'
                }],

                bomshenpi:{
                    shenheyijian:'',
                },
                showhistory:false,
                //流程id
                instid:'',
                taskid:'',
                //物料id
                ywid:'',
                //taskid
                taskid:'',
                taskstatus:'',
                sceneList:[],
                productType: [],//大类list
                showTransit:false,
                bomId:null,
                tcUrl:null,
                showTj:false,
                showSence:false,
                showChildSence:false,
                taxList: [],
                agentList: [],
                caiwuFlag: false,
                isShouh: false,
            }
        },
        created() {
            //业务id
            this.ywid = this.$router.history.current.query.ywid;

            //taskid
            this.taskid = this.$router.history.current.query.taskid;

            //instid
            this.instid = this.$router.history.current.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            this.query();
            this.checkfin();
        },
        methods: {

            query() {
                this.f.id = this.$route.query.ywid;
                ss.bom.selectById(this.f.id).then(rd => {
                    this.f = rd.obj;
                    if(this.f.isTj === 1 ){
                        this.f.isTj = '1'
                    }else if(this.f.isTj === 0){
                        this.f.isTj = '0'
                    }
                    if(this.f.isWhole === 1 ){
                        this.f.isWhole = '1'
                    }else if(this.f.isWhole === 0){
                        this.f.isWhole = '0'
                    }
                    if(this.f.isStep === 1 ){
                        this.f.isStep = '1'
                    }else if(this.f.isStep === 0){
                        this.f.isStep = '0'
                    }
                    if(this.f.isFl === 1 ){
                        this.f.isFl = '1'
                    }else if(this.f.isFl === 0){
                        this.f.isFl = '0'
                    }
                    if(this.f.isTransit === 1 ){
                        this.f.isTransit = '1'
                        this.showTransit = true;
                    }else if(this.f.isTransit === 0){
                        this.f.isTransit = '0'
                    }
                    if(this.f.isFw === 1 ){
                        this.f.isFw = '1'
                    }else if(this.f.isFw === 0){
                        this.f.isFw = '0'
                    }
                    if(this.f.isSingleSale === 1 ){
                        this.f.isSingleSale = '1'
                    }else if(this.f.isSingleSale === 0){
                        this.f.isSingleSale = '0'
                    }
                    if(this.f.isSceneIncome === 1 ){
                        this.f.isSceneIncome = '1'
                    }else if(this.f.isSceneIncome === 0){
                        this.f.isSceneIncome = '0'
                    }
                    if(this.f.isPolicy == '1'){
                        this.showTj = false;
                    }else if(this.f.isPolicy == '0'){
                        this.showTj = true;
                    }

                    //售后套餐
                    if(this.f.lianqunCode == 'SH'){
                        this.isShouh = true;
                    }

                    this.bomDetailData =  this.f.bomDetailList;
                    this.bomId = rd.obj.packageCode;
                    this.changePackage(this.f.packageType);
                    if(this.f.companycode == '44U0' || this.f.companycode == '45K0'){
                        let lianquns = [];
                        lianquns.push("YX1")
                        this.f.useLianqun = "YX1"
                    }
                   })
            },

            tongguobohui(q){
                var shenPiEntity = {
                    yewuzhujian: this.ywid,//业务主键
                    taskid: this.taskid,//页面拿到的taskid
                    msg: this.bomshenpi.shenheyijian,//  页面填写的审核意见
                    jiediantiaojianming:'tongguoorbohui',//通过还是驳回的节点条件名字
                    instid:this.instid,//选择要进入的审批版本id
                    useLianqun:this.f.useLianqun,//客户范围
                }
                // 通过还是驳回的flag  1驳回  2通过
                if(q==1){
                    shenPiEntity.tongguoorbohui=1;
                    shenPiEntity.optflag = '驳回';
                    if (!this.bomshenpi.shenheyijian) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }

                }else if(q==2){

                    shenPiEntity.tongguoorbohui=2;
                    shenPiEntity.optflag = '通过';
                }


                ss.bom.shenpiBom(shenPiEntity).then(rd => {
                    if(rd.f==true){

                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    }
                })
            },
            viewpress(){
                this.showhistory = true;
            },
            //取消按钮
            quxiaoanniu(){

                this.$router.go(-1);

            },
            //获取场景信息
            getSceneList() {
                var data = {
                    lianqunCode:'',
                }
                data.lianqunCode = this.f.lianqunCode
                ss.bom.getSceneList(data).then(rd => {
                    this.sceneList = rd.msg;
                });
            },
            mfIsUpload(v) {
                console.log('mfIsUpload',v)
                if (v.length > 0) {
                    //this.order.fileUrl = v[0].saveurl;
                    let arrnew = []
                    v.forEach(e => {
                        this.f.tcfileUrl = e.saveurl
                        this.tcUrl = e.saveurl
                    })
                    // this.order.mffileUrl = arrnew
                }else{
                    this.f.tcfileUrl =null;
                }
            },
            changePackage() {
                //定制套餐，根据创建订单的角色自动带出对应场景（目前只有云眼、样本、自动化）
                if (this.f.packageType == '1') {
                    var sDate = new Date();
                    this.f.startTime = new Date();
                    this.showSence = true;
                    if(this.f.sceneName == '自产冷库场景'){
                        this.showChildSence = true;
                    }

                    //根据当前人员登录角色获取对应场景（不可修改）
                    if (this.$store.getters.hasRole('swyl_tc_ybgly')) {
                        this.f.sceneCode = 'X02001';
                        this.f.sceneName = '样本库方案场景';
                        //套餐有效期默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    } else if (this.$store.getters.hasRole('swyl_tc_yygly')) {
                        this.f.sceneCode = 'X08001';
                        this.f.sceneName = '智慧实验室场景';
                        //套餐有效期默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    } else if (this.$store.getters.hasRole('swyl_tc_zdhgly')) {
                        this.f.sceneCode = 'X02002';
                        this.f.sceneName = '自动化大项目场景';
                        //套餐有效期默认六个月
                        sDate.setMonth(sDate.getMonth() + 6)
                        this.f.endTime = this.timestampToTime(sDate);
                    }else {
                        //其余定制套餐默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    }
                    this.showTj = true;
                } else if (this.f.packageType == '2') {
                    this.showTj = false;
                    this.showSence = false;
                }
            },
            getTaxcodeList(value) {
                var data = {
                    taxcodeLike: null,
                };
                data.taxcodeLike = value;
                ss.bom.getTaxcodeList(data).then(rd => {
                    this.taxList = rd.msg;
                });
            },
            // 时间戳转换日期
            timestampToTime(timestamp) {
                var  date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear() ;
                let M = (date.getMonth()+1 < 10 ?  '0' +(date.getMonth()+1) : date.getMonth()+1) ;
                let D = date.getDate().toString().padStart(2,0);
                let h = date.getHours() +  ':' ;
                let m = date.getMinutes() +  ':' ;
                let s = date.getSeconds();
                return  Y + '-' + M + '-' + D;//+h+m+s
            },
            //获取指定经销商
            showComList(value) {
                ss.netApi.selectOnlyName(value).then(res => {
                    this.agentList = res.obj
                })
            },
            checkfin(){
                var data = {
                    taskid : null,
                }
                data.taskid = this.taskid;
                ss.bom.checkFin(data).then(rd => {
                    this.caiwuFlag = rd.msg;
                })
            },
        }
    }
</script>
<style>
    .Bianji .h-elformWrap-2 .el-form-item__label {
        width: 26%;
        text-align: right;
    }
    .Bianji .h-elformWrap-2 .el-form-item__content {
        width: 74%;
    }
    .Bianji .h-elformWrap-1 .el-form-item__label {
        width: 8%;
        text-align: right;
    }
    .Bianji .h-elformWrap-1 .el-form-item__content {
        width: 92%;
    }
    .Bianji .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }
    .Bianji .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }
    .w-elformWrap .el-form-item__label {
        width: 10% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 90% !important;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bigDiv {
        margin: 20px;
    }
    .bigDiv .h-piece .top .ccc {
        margin-top: -13px;
    }
</style>
